/**
 * Exception Creators for exceptions that are raised within Sparx Web. Each
 * exception is an Immutable Map with a "type" attribute, and should be
 * created using the provided exception creators. The constant strings
 * should be used to refer to the exceptions' types when catching them.
 */

import { Map } from 'immutable';

export const ABORT_CURRENT_TASKS_EXCEPTION = 'AbortCurrentTasks';

/**
 * An exception that is thrown to abort the user's current activity so that
 * the app can be switched into a different state. This is current used to
 * cancel alerts when the server requests a new task or game in lesson mode.
 * @returns {*|Map<K, V>|Map<string, V>}
 */
export function abortCurrentTasksException() {
    return Map({ type: ABORT_CURRENT_TASKS_EXCEPTION });
}
